import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const companyLinks = [
  { label: 'Terms & Conditions', slug: 'terms-and-conditions' },
  { label: 'Refund and Transfer Policies', slug: 'refund-process' },
  { label: 'Privacy Policy', slug: 'privacy-policy' },
  { label: 'FAQs', slug: 'faqs' },
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img
            src="https://jaipuria.edu.in/wp-content/uploads/2021/07/sajes_great_place_logo.jpg"
            alt="Logo"
            className="footer-logo"
          />
          <h3>Community Library Management System</h3>
          <p>Welcome to Jaipuria Community Library Center!</p>
        </div>

        <div className="footer-links">
          <h4 className="footer-links-heading">Company</h4>
          <ul className="footer-link-list">
            {companyLinks.map((link) => (
              <li key={link.slug}>
                <Link to={`/${link.slug}`}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} Jaipuria Group of Educational Institutions. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
